export enum VeldaEntities {
    ARTICLES = 'articles',
    ARTICLESCATEGORIES = 'article categories',
    BRANDS = 'brands',
    COLLECTIONS = 'collections',
    SUBCOLLECTIONS = 'subcollections',
    DEALERS = 'dealers',
}
